export const TOGGLE_LIGHTS = 'toggle:lights';
export const TOGGLE_SIDEBAR = 'toggle:sidebar';
export const STICK_SETTING = 'sticky';
export const LOADING = 'loading';
export const LOAD_STRUCTURE = 'structure';
export const UPDATE_PATH = 'path';
export const SERVER_ERROR = 'error';
export const TIME_TRAVEL = 'time:travel';
